import("retinajs");
import { Modal } from "bootstrap";
import { scrollNav } from "./modules/scrollNav";
import { initAlpine } from "./modules/initAlpine";

scrollNav();
initAlpine();
